webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(65);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(14);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _router = __webpack_require__(27);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default },
	  router: _router2.default
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(28);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _localstorage = __webpack_require__(24);
	
	var _localstorage2 = _interopRequireDefault(_localstorage);
	
	var _session = __webpack_require__(25);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _cookies = __webpack_require__(22);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _json = __webpack_require__(23);
	
	var _json2 = _interopRequireDefault(_json);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storage = {
	  config: {
	    type: 'local',
	    expires: new Date().getTime() + 100 * 24 * 60 * 60 * 1000
	  },
	  getStorage: function getStorage(options) {
	    var config = {};
	    if (options) {
	      config = (0, _assign2.default)({}, this.config, options);
	    } else {
	      config = this.config;
	    }
	    return this.createStorage(config.type);
	  },
	  createStorage: function createStorage(name) {
	    switch (name) {
	      case 'local':
	        return _localstorage2.default;break;
	      case 'session':
	        return _session2.default;break;
	      case 'cookies':
	        return _cookies2.default;break;
	      case 'json':
	        return _json2.default;break;
	    }
	  },
	  getItem: function getItem(key, options) {
	    var store = this.getStorage(options);
	    return store.getItem(key);
	  },
	  setItem: function setItem(key, value, options) {
	    var store = this.getStorage(options);
	    store.setItem(key, value);
	  },
	  removeItem: function removeItem(key, options) {
	    var store = this.getStorage(options);
	    store.removeItem(key);
	  },
	  getAll: function getAll() {},
	  clear: function clear(options) {
	    var store = this.getStorage(options);
	    store.clear();
	  },
	  key: function key(n) {},
	  lenght: function lenght() {},
	  has: function has(key) {},
	  forEach: function forEach(cb) {},
	  deleteAllExpires: function deleteAllExpires() {},
	  getMaxSpace: function getMaxSpace(options) {
	    var store = this.getStorage(options);
	    store.getMaxSpace();
	  },
	  getUsedSpace: function getUsedSpace(options) {
	    var store = this.getStorage(options);
	    store.getUsedSpace();
	  }
	};
	exports.default = storage;

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "app",
	    data: function data() {
	        return {
	            menulist: [{ "name": "首页", url: "/home" }, { "name": "用户", url: "/user/18" }, { "name": "产品", url: "/product/20" }]
	        };
	    }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storage = __webpack_require__(7);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HelloWorld',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  },
	
	
	  methods: {
	    golist: function golist() {
	      var _this = this;
	      _this.$router.push({ path: "/user/20" });
	    },
	    routeDetail: function routeDetail() {
	      this.$route.router.push({
	        uri: '/user'
	      });
	    },
	
	    restart: function restart() {
	      _storage2.default.setItem('gold', 30);
	    }
	  }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "product",
	    data: function data() {
	        return {
	            msg: "这里是product视图"
	        };
	    }
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toast = __webpack_require__(26);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _common = __webpack_require__(21);
	
	var _storage = __webpack_require__(7);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "user",
	  data: function data() {
	    return {
	      topic_id: 0,
	      title_nums: 1,
	      gold_total_nums: 30,
	      topic_info: {
	        "topic_title": 1,
	        "topic_choice": [1, 2, 3, 4],
	        "topic_answer": 3
	      },
	
	      topic_array: _common.topic_array,
	
	      show: 'none',
	      add_gold: '得到1个金币',
	
	      answer_info: '回答正确',
	      isShow: false
	    };
	  },
	
	  created: function created() {
	    this.topic_array = _common.topic_array;
	
	    this.part_total_nums = this.topic_array.length;
	    console.log("---", this.part_total_nums);
	    this.title_nums = 1;
	    this.gold_total_nums = 30;
	    this.show = 'none';
	
	    this.topic_id = _storage2.default.getItem("part_current_id");
	
	    if (this.topic_id == null || this.topic_id == undefined) {
	      this.topic_id = 0;
	      _storage2.default.setItem("part_current_id", this.topic_id);
	    }
	    this.title_nums = parseInt(this.topic_id) + 1;
	    this.topic_info = (0, _common.get_topic_info)(this.topic_id);
	
	    this.gold_total_nums = this.get_gold_total_nums();
	  },
	
	  methods: {
	    choice_button: function choice_button(index) {
	      if (index == this.topic_info.topic_answer) {
	        console.log("ok");
	
	        this.isShow = true;
	        this.topic_id++;
	
	        this.gold_total_nums = parseInt(this.gold_total_nums) + 1;
	        this.set_gold_total_nums(this.gold_total_nums);
	
	        if (this.topic_id == this.part_total_nums) {
	          this.answer_info = '居然到最后一道了，牛';
	          this.show = 'flex';
	        } else {
	          this.title_nums++;
	          this.show = 'flex';
	
	          this.set_part_id(this.topic_id);
	        }
	      } else {}
	    },
	
	    hint_button: function hint_button() {
	      var _this = this;
	
	      var gold_tmp = this.gold_total_nums - 30;
	
	      if (gold_tmp >= 0) {
	        _this.gold_total_nums = gold_tmp;
	        this.$forceUpdate();
	        (0, _toast2.default)({
	          message: "正确",
	          position: 'center',
	          duration: 1000
	        });
	      } else {
	        console.log("000");
	        (0, _toast2.default)({
	          message: "错误",
	          position: 'top',
	          duration: 1000
	        });
	      }
	    },
	
	    next_button: function next_button() {
	      if (this.topic_id < this.part_total_nums) {
	        this.topic_info = (0, _common.get_topic_info)(this.topic_id);
	
	
	        this.title_nums = this.topic_id;
	        this.title_nums++;
	
	        this.show = 'none';
	        this.isShow = false;
	      } else {}
	      this.$forceUpdate();
	    },
	
	    set_part_id: function set_part_id(part_id) {
	      _storage2.default.setItem('part_current_id', part_id);
	    },
	
	    get_gold_total_nums: function get_gold_total_nums() {
	      this.gold_total_nums = _storage2.default.getItem('gold');
	      console.log('777', this.gold_total_nums);
	      if (this.gold_total_nums == 'null' || this.gold_total_nums == '' || this.gold_total_nums == NaN || this.gold_total_nums == undefined) {
	        this.gold_total_nums = 30;
	      }
	      console.log("888", this.gold_total_nums);
	      return this.gold_total_nums;
	    },
	
	    set_gold_total_nums: function set_gold_total_nums(gold_total_nums) {
	      _storage2.default.setItem('gold', gold_total_nums);
	    }
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      visible: false,
	      message: '',
	      position: ''
	    };
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var topic_array = ['少壮不努力#何时复西归#老大徒伤悲#缘愁似个长#当春乃发生#2', '少小离家老大回#笑问客从何处来#二月春风似剪刀#乡音无改鬓毛衰#门泊东吴万里船#3', '此曲只应天上有#天上能得几回闻#人间哪得几回闻#落花时节又逢君#人间能得几回闻#4', '正是江南好风景#落花时节又逢君#长使英雄泪满襟#莫使金樽空对月#无人知是荔枝来#1', '好雨知时节#当春乃发生#把酒问青天#一览众山小#长河落日圆#1', '随风潜入夜#润物俱无声#湿物细无声#润物细无声#大雪满弓刀#3', '柴门闻犬吠#风雨夜归人#风雨夜回人#风雪夜回人#风雪夜归人#4', '千山鸟飞绝#万径人踪灭#独钓寒江雪#可怜无数山#只是近黄昏#1', '孤舟蓑笠翁#独钓寒江雪#垂钓寒江雪#垂钓松江雪#独钓松江雪#1', '月落乌啼霜满天#夜半钟声到客船#江枫渔火对愁眠#春来江水绿如蓝#明月何时照我还#2', '西塞山前白鹭飞#梨花流水鳜鱼肥#桃花流水桂鱼肥#桃花流水鳜鱼肥#梨花流水桂鱼肥#3', '欲将轻骑逐#月涌大江流#大雪满弓刀#月是故乡明#清泉石上流#2', '慈母手中线#游子身上衣#临行密密缝#意恐迟迟归#报得三春晖#1', '东边日出西边雨#二月春风似剪刀#道是无晴却有晴#春风不度玉门关#万里长征人未还#2', '旧时王谢堂前燕#飞入平常百姓家#飞到寻常百姓家#飞到平常百姓家#飞入寻常百姓家#4', '日出江花红胜火#春来江水绿如蓝#明月何时照我还#夜半钟声到客船#江枫渔火对愁眠#1', '谁知盘中餐#颗颗皆辛苦#粒粒都辛苦#粒粒皆辛苦#颗颗都辛苦#3', '远上寒山石径斜#乌云生处有人家#白云生处有人家#彩云生处有人家#青云生处有人家#2', '停车坐爱枫林晚#枫叶红于二月花#霜叶红于五月花#枫叶红于五月花#霜叶红于二月花#4', '借问酒家何处有#多少楼台烟雨中#牧童遥指杏花村#总把新桃换旧符#明月何时照我还#2', '南朝四百八十寺#多少楼台烟雨中#多少楼阁烟雨中#多少楼台雾雨中#多少楼阁雾雨中#1', '夕阳无限好#已是近黄昏#只是到黄昏#只是近黄昏#已是到黄昏#3', '千门万户曈曈日#多少楼台烟雨中#万里长征人未还#牧童遥指杏花村#总把新桃换旧符#4', '春风又绿江南岸#明月何时照我还#夜半钟声到客船#江枫渔火对愁眠#春来江水绿如蓝#1', '欲把西湖比西子#浓抹淡妆总相宜#淡妆浓抹总相宜#淡妆浓抹皆相宜#浓抹淡妆皆相宜#2', '竹外桃花三两枝#正是河豚欲上时#在地愿为连理枝#万里长征人未还#春江水暖鸭先知#4', '横看成岭侧成峰#远近高低各不同#但悲不见九州同#映日荷花别样红#半江瑟瑟半江红#1', '至今思项羽#不愿过江东#不想过江东#不肯过江东#不敢过江东#3', '王师北定中原日#家祭无忘告乃翁#但悲不见九州同#死去元知万事空#烈火焚烧若等闲#1', '接天莲叶无穷碧#半江瑟瑟半江红#化作春泥更护花#露似珍珠月似弓#映日荷花别样红#4'];
	
	function get_topic_info(topic_id) {
	    var topic = topic_array[topic_id].split("#");
	    var topic_info = {
	        "topic_title": topic[0],
	        "topic_choice": [topic[1], topic[2], topic[3], topic[4]],
	        "topic_answer": topic[5]
	    };
	    return topic_info;
	}
	
	exports.topic_array = topic_array;
	exports.get_topic_info = get_topic_info;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getItem: function getItem(key) {},
	  setItem: function setItem(key, value) {},
	  removeItem: function removeItem(key) {},
	  getAll: function getAll() {},
	  clear: function clear() {},
	  key: function key(n) {},
	  forEach: function forEach(cb) {},
	  has: function has(key) {},
	  deleteAllExpires: function deleteAllExpires() {}
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getItem: function getItem(key) {},
	  setItem: function setItem(key, value) {},
	  removeItem: function removeItem(key) {},
	  getAll: function getAll() {},
	  clear: function clear() {},
	  key: function key(n) {},
	  forEach: function forEach(cb) {},
	  has: function has(key) {},
	  deleteAllExpires: function deleteAllExpires() {}
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getItem: function getItem(key) {
	    var item = localStorage.getItem(key);
	
	    var result = /^[{\[].*[}\]]$/g.test(item);
	    if (result) {
	      return JSON.parse(item);
	    } else {
	      return item;
	    }
	  },
	  setItem: function setItem(key, value) {
	    if (typeof value == "string") {
	      localStorage.setItem(key, value);
	    } else {
	      var _item = (0, _stringify2.default)(value);
	      localStorage.setItem(key, _item);
	    }
	  },
	  removeItem: function removeItem(key) {
	    localStorage.removeItem(key);
	  },
	  getAll: function getAll() {},
	  clear: function clear() {
	    localStorage.clear();
	  },
	  key: function key(n) {},
	  forEach: function forEach(cb) {},
	  has: function has(key) {},
	  deleteAllExpires: function deleteAllExpires() {},
	  getMaxSpace: function getMaxSpace() {
	    if (!window.localStorage) {
	      console.log('当前浏览器不支持localStorage!');
	    }
	    var test = '0123456789';
	    var add = function add(num) {
	      num += num;
	      if (num.length == 10240) {
	        test = num;
	        return;
	      }
	      add(num);
	    };
	    add(test);
	    var sum = test;
	    var show = setInterval(function () {
	      sum += test;
	      try {
	        window.localStorage.removeItem('test');
	        window.localStorage.setItem('test', sum);
	        console.log(sum.length / 1024 + 'KB');
	      } catch (e) {
	        console.log(sum.length / 1024 + 'KB超出最大限制');
	        clearInterval(show);
	      }
	    }, 0.1);
	  },
	  getUsedSpace: function getUsedSpace() {
	    if (!window.localStorage) {
	      console.log('浏览器不支持localStorage');
	    }
	    var size = 0;
	    for (item in window.localStorage) {
	      if (window.localStorage.hasOwnProperty(item)) {
	        size += window.localStorage.getItem(item).length;
	      }
	    }
	    console.log('当前localStorage使用容量为' + (size / 1024).toFixed(2) + 'KB');
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getItem: function getItem(key) {
	    var item = sessionStorage.getItem(key);
	
	    var result = /^[{\[].*[}\]]$/g.test(item);
	    if (result) {
	      return JSON.parse(item);
	    } else {
	      return item;
	    }
	  },
	  setItem: function setItem(key, value) {
	    if (typeof value == "string") {
	      sessionStorage.setItem(key, value);
	    } else {
	      var _item = (0, _stringify2.default)(value);
	      sessionStorage.setItem(key, _item);
	    }
	  },
	  removeItem: function removeItem(key) {
	    sessionStorage.removeItem(key);
	  },
	  getAll: function getAll() {},
	  clear: function clear() {
	    sessionStorage.clear();
	  },
	  key: function key(n) {},
	  forEach: function forEach(cb) {},
	  has: function has(key) {},
	  deleteAllExpires: function deleteAllExpires() {},
	  getMaxSpace: function getMaxSpace() {
	    if (!window.sessionStorage) {
	      console.log('当前浏览器不支持sessionStorage!');
	    }
	    var test = '0123456789';
	    var add = function add(num) {
	      num += num;
	      if (num.length == 10240) {
	        test = num;
	        return;
	      }
	      add(num);
	    };
	    add(test);
	    var sum = test;
	    var show = setInterval(function () {
	      sum += test;
	      try {
	        window.sessionStorage.removeItem('test');
	        window.sessionStorage.setItem('test', sum);
	        console.log(sum.length / 1024 + 'KB');
	      } catch (e) {
	        console.log(sum.length / 1024 + 'KB超出最大限制');
	        clearInterval(show);
	      }
	    }, 0.1);
	  },
	  getUsedSpace: function getUsedSpace() {
	    if (!window.sessionStorage) {
	      console.log('浏览器不支持sessionStorage');
	    }
	    var size = 0;
	    for (item in window.sessionStorage) {
	      if (window.sessionStorage.hasOwnProperty(item)) {
	        size += window.sessionStorage.getItem(item).length;
	      }
	    }
	    console.log('当前sessionStorage使用容量为' + (size / 1024).toFixed(2) + 'KB');
	  }
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToastConstructor = _vue2.default.extend(__webpack_require__(69));
	var removeDom = function removeDom(event) {
	  event.target.parentNode.removeChild(event.target);
	};
	ToastConstructor.prototype.close = function () {
	  this.visible = false;
	  this.$el.addEventListener('transitionend', removeDom);
	};
	var Toast = function Toast() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  var instance = new ToastConstructor().$mount(document.createElement('div'));
	  var duration = options.duration || 2500;
	  instance.message = typeof options === 'string' ? options : options.message;
	  instance.position = options.position || 'middle';
	  document.body.appendChild(instance.$el);
	  instance.visible = true;
	  _vue2.default.nextTick(function () {
	    instance.timer = setTimeout(function () {
	      instance.close();
	    }, duration);
	  });
	  return instance;
	};
	
	exports.default = Toast;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueRouter = __webpack_require__(14);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(66);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _User = __webpack_require__(68);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Product = __webpack_require__(67);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vueRouter2.default({
	    routes: [{ path: "/", component: _Home2.default }, { path: "/home", component: _Home2.default }, { path: "/user/:id", component: _User2.default }, { path: "/product/:id", component: _Product2.default }]
	});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(59)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(16),
	  /* template */
	  __webpack_require__(72),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(58)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(17),
	  /* template */
	  __webpack_require__(71),
	  /* scopeId */
	  "data-v-19c65d6c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(61)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(18),
	  /* template */
	  __webpack_require__(74),
	  /* scopeId */
	  "data-v-42e44272",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(60)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(19),
	  /* template */
	  __webpack_require__(73),
	  /* scopeId */
	  "data-v-26defe58",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(57)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(70),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "toast",
	    class: _vm.position
	  }, [_c('i', [_vm._v(_vm._s(_vm.message))])])])
	},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "demo-page"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "btn",
	    attrs: {
	      "type": "button",
	      "value": "开始"
	    },
	    on: {
	      "click": _vm.golist
	    }
	  })]), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "btn",
	    attrs: {
	      "type": "button",
	      "value": "重置"
	    },
	    on: {
	      "click": _vm.restart
	    }
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', {
	    staticClass: "title"
	  }, [_vm._v("\"古诗词大作战\"")])])
	}]}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "topic_content"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [_c('div', {
	    staticClass: "topic_top_right"
	  }, [_c('label', {
	    staticClass: "topic_top_text"
	  }, [_vm._v("第" + _vm._s(_vm.title_nums) + "题")])]), _vm._v(" "), _c('div', {
	    staticClass: "topic_top_left",
	    staticStyle: {
	      "background-size": "250px 100px"
	    }
	  }, [_c('label', {
	    staticClass: "level_text"
	  }, [_vm._v(_vm._s(_vm.gold_total_nums))])])]), _vm._v(" "), _c('div', {
	    staticClass: "topic"
	  }, [_c('div', {
	    staticClass: "topic_left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "topic_center"
	  }, [_c('div', [_c('label', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.topic_info.topic_title))])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.choice_button(1)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[0]))])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.choice_button(2)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[1]))])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.choice_button(3)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[2]))])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.choice_button(4)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.topic_info.topic_choice[3]))])])]), _vm._v(" "), _c('div', {
	    staticClass: "topic_right"
	  }, [_c('div', {
	    staticClass: "hint_button"
	  }, [_c('input', {
	    staticClass: "hit_button",
	    attrs: {
	      "type": "button",
	      "value": "提示"
	    },
	    on: {
	      "click": _vm.hint_button
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShow),
	      expression: "isShow"
	    }],
	    staticClass: "mask_background"
	  }, [_c('div', {
	    staticClass: "mask_info_background"
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "60%"
	    }
	  }, [_c('div', {
	    staticClass: "mask_info_text"
	  }, [_c('label', [_vm._v(_vm._s(_vm.answer_info))])]), _vm._v(" "), _c('div', {
	    staticClass: "mask_info_text"
	  }, [_c('label', [_vm._v(_vm._s(_vm.add_gold))])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "align-items": "center",
	      "justify-content": "center"
	    }
	  }, [_c('input', {
	    staticClass: "mask_button",
	    attrs: {
	      "type": "button",
	      "value": "下一关"
	    },
	    on: {
	      "click": _vm.next_button
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "product"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.msg) + "，获取到的参数是：" + _vm._s(_vm.$route.params.id))])])
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.498fc16a55004f9efef7.js